import { formatCurrency, formatDateHuman } from "../date-utils";
export const activityDtoFields = [{
        name: "date",
        title: "Data",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(record.activity.date)
    }, {
        name: "dossierProtocol",
        title: "Pratica"
    }, {
        name: "customerName",
        title: "Cliente"
    }, {
        name: "activityTypeDescription",
        title: "Causale Attività"
    }, {
        name: "title",
        title: "Descrizione aggiuntiva",
        render: (record) => record.activity.title
    }, {
        name: "elapsedTime",
        title: "Tempo",
        render: (record) => record.activity.hours.toString().padStart(2, '0') + ':' + record.activity.minutes.toString().padStart(2, '0')
    }, {
        name: "costsAmount",
        title: "Costi Anticipati",
        render: (record) => record.activity.costs === 1 ? formatCurrency(record.activity.costsAmount) : ''
    }, {
        name: "billed",
        title: "Fatturata",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.activity.billed === 1 ? "verified" : "panorama_fish_eye"}</i>`
    }, {
        name: "portalUserName",
        title: "Utente"
    }];
